exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sustainability-tool {\n  background: #dddddd;\n}\n.sustainability-tool path {\n  fill-opacity: 0.25;\n}\n\n.mtt-sustainability-tool__graph .shape {\n  fill-opacity: 0.05;\n}\n.mtt-sustainability-tool__graph .shape:hover {\n  fill-opacity: 0.3;\n  z-index: 100;\n}", ""]);

// exports
